import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideNotification } from "../../../../store/actions";
import { GlobalState } from "../../../../store/types";
import classNames from "classnames";
import "./style.scss";

const AUTOHIDE_TIMEOUT = 10_000;

const NotificationPanel: React.FC = () => {
    const { message, type, visible } = useSelector((state: GlobalState) => state.notification);
    const dispatch = useDispatch();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const [shouldRender, setShouldRender] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (visible) {
            setShouldRender(true);
            setTimeout(() => setIsVisible(true), 10); // чуть позже, чтобы transition сработал
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => dispatch(hideNotification()), AUTOHIDE_TIMEOUT); // safety
            }, AUTOHIDE_TIMEOUT);
        } else if (shouldRender) {
            setIsVisible(false);
        }

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
        // eslint-disable-next-line
    }, [visible, message, dispatch]);


    const handleTransitionEnd = () => {
        if (!isVisible) setShouldRender(false);
    };

    if (!shouldRender) return null;

    return (
        <div
            className={classNames(
                "notification-panel",
                `notification-panel--${type}`,
                { "notification-panel--visible": isVisible }
            )}
            role="alert"
            aria-live="assertive"
            tabIndex={0}
            onTransitionEnd={handleTransitionEnd}
        >
            <span className="notification-panel__icon" aria-hidden="true">
                {type === "error" && "⛔"}
                {type === "success" && "✅"}
                {type === "info" && "ℹ️"}
            </span>
            <span className="notification-panel__message">{message}</span>
            <button
                className="notification-panel__close"
                aria-label="Закрыть уведомление"
                onClick={() => { setIsVisible(false); dispatch(hideNotification()); }}
            >
                ×
            </button>
        </div>
    );
};

export default NotificationPanel; 
